import { prop } from "fw";
import { ContactsKeywordFilter as ContactsKeywordFilterModel } from "models/contacts-filters";

export class ContactsKeywordFilter {
  @prop(null) filter!: ContactsKeywordFilterModel;
  @prop(() => ({})) validation;
  @prop(false) editing!: boolean;
}
